import { generateDatiqLogMessage } from '@dat/datiq-log';
import { gql } from 'apollo-angular';

export const DatiqGeoLogPrefix: string = '[Geo]';

export const generateDatiqLogMessageGeo: (message: string) => string = (
    message: string,
) => generateDatiqLogMessage(DatiqGeoLogPrefix, message);

export const suggestionsGraphqlQuery = gql`
    query ($searchText: String) {
        suggestions(searchText: $searchText) {
            displayName
            city
            stateProv
            postalCode
            county
            pointId: placeId
            latitude
            longitude
        }
    }
`;
